import HeadingDemo from './HeadingDemo'

export default HeadingDemo
// eslint-disable-next-line import/export
export * from './HeadingDemo'
